import {view} from '@sail/ui';
import {getStore} from 'src/v2/state/store';
import {defineMessages, FormattedMessage} from 'react-intl';
import {MerchantLogo, Text, Link} from 'src/v2/components/common';
import {getAccessibleTextColor} from 'src/v2/util/getAccessibleTextColor';
import {TestmodeBadge} from 'src/components/core/TestmodeBadge';

const messages = defineMessages({
  needHelp: {
    id: 'crypto.payins.v2.header.need_help',
    description: 'Link to the Stripe support page',
    defaultMessage: 'Need help?',
  },
});

export const Header = () => {
  const store = getStore();

  const businessName = store.useSelector(
    (state) => state.merchantBranding.businessName,
  );
  const logoUrl = store.useSelector((state) => state.merchantBranding.logoUrl);
  const backgroundColor = store.useSelector(
    (state) => state.merchantBranding.backgroundColor,
  );
  const livemode = store.useSelector((state) => state.livemode);

  const primaryTextColor = getAccessibleTextColor(backgroundColor, 'primary');

  return (
    <view.div
      css={{
        stack: 'x',
        height: 'space.900',
        distribute: 'space-between',
        alignY: 'center',
        backgroundColor,
        padding: '0px 40px',
      }}
      data-testid="v2-header"
    >
      <view.div
        css={{
          stack: 'x',
          gap: 'small',
          alignY: 'center',
          width: 'fit',
        }}
      >
        <MerchantLogo
          logoUrl={logoUrl}
          businessName={businessName}
          style={{width: '32px', height: '32px', borderRadius: '50%'}}
        />
        <Text type="bodyEmphasized" css={{color: primaryTextColor}}>
          {businessName}
        </Text>
        {!livemode ? <TestmodeBadge /> : null}
      </view.div>

      <Link
        type="secondary"
        href="https://support.stripe.com/user/topics/stablecoin-and-crypto-payments"
        target="_blank"
      >
        <Text
          type="body"
          css={{
            color: getAccessibleTextColor(backgroundColor, 'subdued'),
            ':hover': {
              color: getAccessibleTextColor(backgroundColor, 'primary'),
            },
          }}
        >
          <FormattedMessage {...messages.needHelp} />
        </Text>
      </Link>
    </view.div>
  );
};
